import type { Dispatch, SetStateAction, ReactNode } from "react";
import type { UseFormGetValues, UseFormSetValue } from "react-hook-form";
import type { ICampaignWizardForm } from "../../../../../../../../../shared/types/form.type";

export type CountryListItem = { key: string; node: ReactNode };

/** Формирует обработчики выбора / удаления стран для поля geo_targets формы. */
export function createCountryTargetHandlers(params: {
	allKey: string;
	countriesItems: CountryListItem[];
	getValues: UseFormGetValues<ICampaignWizardForm>;
	setValue: UseFormSetValue<ICampaignWizardForm>;
	setSelectedCountries: Dispatch<SetStateAction<CountryListItem[]>>;
}) {
	const { allKey, countriesItems, getValues, setValue, setSelectedCountries } =
		params;

	// Добавляет страну в geo_targets и в локальный список выбранных (псевдо-ключ «все» пропускаем).
	const onCountrySelect = (key: string) => {
		if (key === allKey) return;
		const item = countriesItems.find((i) => i.key === key);
		if (!item) return;
		const prev = getValues("campaign_context.campaign.geo_targets") ?? [];
		const nextKeys = [...prev, item.key];
		setSelectedCountries((s) => [...s, item]);
		setValue("campaign_context.campaign.geo_targets", nextKeys, {
			shouldDirty: true,
		});
	};

	// Удаляет страну из geo_targets и из локального списка выбранных.
	const onCountryRemove = (key: string) => {
		const prev = getValues("campaign_context.campaign.geo_targets") ?? [];
		const nextKeys = prev.filter((k: string) => k !== key);
		setSelectedCountries((s) => s.filter((i) => i.key !== key));
		setValue("campaign_context.campaign.geo_targets", nextKeys, {
			shouldDirty: true,
		});
	};

	return { onCountrySelect, onCountryRemove };
}
